// extracted by mini-css-extract-plugin
export default {"authButton":"AccountAuthButton--authButton--vcyqP","placeholder":"AccountAuthButton--placeholder--8aCI1","facebookBlue":"AccountAuthButton--facebookBlue--d+bCw"};